module.exports = __webpack_public_path__ + "img/order-info-m.0bfd0298.png";